module.exports = __webpack_public_path__ + "static/img/good-detail-yinliu.74228773.png";